import createStore from "react-recontext";
import initialState from "./initialState";
import actionsCreators from "./actions";

const enableLogger = false;

export const { Provider, connect, dispatch } = createStore(
  initialState,
  actionsCreators,
  enableLogger
);
